module.exports = __webpack_public_path__ + "static/8-cf5be0ff67e48e2980367d749341b883.svg";